import dayjs from 'dayjs';

export const getOrdinalSuffix = day => {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

export const formatDayLabel = date => {
  if (date.isSame(dayjs(), 'day')) return 'Today';
  return `${date.date()}${getOrdinalSuffix(date.date())}`;
};

export const buildWeekDays = activityDays => {
  const completedDates = new Set(
    (activityDays || []).map(d => dayjs(d).format('YYYY-MM-DD')),
  );

  return Array.from({ length: 7 }, (_, index) => {
    const date = dayjs().subtract(6 - index, 'day');
    const dateKey = date.format('YYYY-MM-DD');
    const isToday = date.isSame(dayjs(), 'day');
    const isCompleted = completedDates.has(dateKey);

    return {
      key: dateKey,
      label: formatDayLabel(date),
      isToday,
      isCompleted,
    };
  });
};

export const getActivityDays = attributes => {
  if (!attributes) return [];
  const activity = attributes.activity || attributes.activity_data;
  if (Array.isArray(activity?.days)) return activity.days;
  if (Array.isArray(attributes.activity_days)) return attributes.activity_days;
  if (Array.isArray(attributes.weekly_activity))
    return attributes.weekly_activity;
  return [];
};

export const getStreakLine = (streakState, currentStreakWeeks) => {
  if (streakState === 'none') return 'Start your streak this week.';
  if (streakState === 'ended') {
    return 'Missing one week happens. Come back this one.';
  }
  if (streakState !== 'active') return null;

  const weeks = Number(currentStreakWeeks);
  if (weeks === 1) return "You're on a 1-week streak. Keep it going!";
  if (Number.isInteger(weeks) && weeks >= 2) {
    return `You're on a ${weeks}-week streak. Keep it going!`;
  }
  return null;
};

export const getStreakWeeks = attributes => {
  if (!attributes) return 0;
  const activity = attributes.activity || attributes.activity_data;
  return (
    activity?.week_streak ??
    activity?.streak_weeks ??
    attributes.week_streak ??
    attributes.streak_weeks ??
    attributes.activity_streak ??
    0
  );
};

export const buildWeekDaysFromCommunityStats = dailyActivity => {
  if (!dailyActivity?.length) return null;
  return dailyActivity.map(day => {
    const date = dayjs(day.date);
    return {
      key: day.date,
      label: formatDayLabel(date),
      isToday: date.isSame(dayjs(), 'day'),
      isCompleted: day.watched,
    };
  });
};

export const getTimeOfDayGreeting = () => {
  const hour = dayjs().hour();
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
};

export const getFirstName = name => {
  if (!name || typeof name !== 'string') return '';
  return name.trim().split(/\s+/)[0];
};
